<template lang="pug">
    div
        v-select(
            class="style-chooser"
            :options="options" 
            :multiple="multiple"
            :placeholder="placeholder"
            @search="getOptionsDebounce"
            :filterable="false"
            :value="isUseWithStore ? $store.state.dashboard.queryFilter.tags : value"
            @input="updateValue"
            :taggable="taggable"
            :createOption="createOption"
        )
            span(slot="no-options") {{ $t('main.selectNotFoundText') }}
</template>
<script>
import { getFormOptions } from "@/api/formoptions";
import { _debounce, isSameJson } from "@/libs/utils";
export default {
    name: "TagSelector",
    components: {},
    props: {
        value: {},
        multiple: { type: Boolean, default: true },
        indexName: { type: String, default: "" },
        placeholder: { type: String, default: "Tags" },
        isUseWithStore: { type: Boolean, default: true },
        taggable: { type: Boolean, default: true },
    },
    watch: {
        groupNames: function(newVal, oldVal) {
            if (!isSameJson(newVal, oldVal)) {
                if (this.isUseWithStore) this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "tags", value: [] });
                this.getOptions();
            }
        },
        "indexName.length": function(newVal, oldVal) {
            if (this.isUseWithStore) this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "tags", value: [] });
            this.getOptions();
        }
    },
    data() {
        return {
            options: []
        };
    },
    computed: {
        groupNames() {
            let groupNames = this.$store.state.dashboard.queryFilter.groupNames;
            // return groupNames.length > 0 ? groupNames : "all";
            return groupNames.length > 0 ? groupNames : this.$store.state.queryGroupName;
        },
        getOptionsQueryString() {
            let searchParams = {};
            searchParams.groupNames = this.groupNames;
            searchParams.indexName = this.indexName;
            return new URLSearchParams(searchParams).toString();
        }
    },
    methods: {
        getOptions() {
            getFormOptions(`/groupby/tags?${this.getOptionsQueryString}`).then(res => {
                this.options = res.data.options;
            });
        },
        updateValue(value) {
            if (this.isUseWithStore) this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "tags", value: value });
            this.$emit("input", value);
        },
        createOption(newOption) {
            return newOption;
        },
    },
    mounted() {
        this.getOptions();
    },
    created() {
        // this.$emit("input", this.$store.state.dashboard.queryFilter.tags);
        var self = this;
        this.getOptionsDebounce = _debounce(function(queryValue, loading) {
            loading(true);
            queryValue = queryValue || "";
            getFormOptions(`/groupby/tags?tags=*${queryValue}*&${self.getOptionsQueryString}`).then(res => {
                self.options = res.data.options;
                loading(false);
            });
        });
    },
    destroyed() {},
    beforeDestroy() {}
};
</script>



// WEBPACK FOOTER //
// src/components/FormItems/TagSelector.vue